<google-map width="100%" height="100%" [center]="mapCenter" [zoom]="13" [options]="mapOptions"></google-map>
<app-offer-preview *ngIf="selectedOffer" [selectedOffer]="selectedOffer" (xClicked)="selectedOffer=null"
                   [@slideInOutPreview]>
</app-offer-preview>
<div class="tooltip" [ngStyle]="{'opacity': tooltipInfo?1:0}" #tooltip [innerHTML]="tooltipInfo"></div>
<app-offer-filter *ngIf="offS.mapMarkers && filterOpen" [offers]="offS.mapProperties" [markers]="offS.mapMarkers"
                  (close)="filterOpen=false"
                  [@slideInOutFilter] (click)="selectedOffer=null">
</app-offer-filter>
<div class="filter" *ngIf="!filterOpen" (click)="filterOpen = true" [@slideInOutFilter]>
  <img [src]="'assets/images/filter.png'" alt="">
</div>
